import { v4 as uuid } from 'uuid';

import { Channel } from 'chaika-enums';

import { NotificationApi } from '@api/NotificationApi';
import { translate } from '@chaika/i18n/helper';

interface SendPaymentUrlData {
    ehrId: string;
    channelId: string;
    paymentUrl: string;
    text?: string;
    channelName: Channel;
}

interface SendAppDownloadLinkData {
    ehrId: string;
    phone: string;
    link: string;
}

const enum NotificationEvent {
    SendPaymentUrl = 'sendPaymentUrl',
    SendAppDownloadLink = 'sendAppDownloadLink',
}

class NotificationService {
    public async sendPaymentUrl({
        ehrId,
        channelId,
        channelName,
        paymentUrl,
        text = translate('paymentUrlText'),
    }: SendPaymentUrlData): Promise<void> {
        await NotificationApi.sendMessage({
            channelId,
            channelName,
            id: uuid(),
            recipientId: ehrId,
            event: NotificationEvent.SendPaymentUrl,
            message: `${text} ${paymentUrl}`,
        });
    }

    public async sendAppDownloadLink({ ehrId, phone, link }: SendAppDownloadLinkData): Promise<void> {
        await NotificationApi.sendMessage({
            channelId: phone,
            channelName: Channel.Sms,
            id: uuid(),
            recipientId: ehrId,
            event: NotificationEvent.SendAppDownloadLink,
            message: translate('$appDownloadLinkSmsText', { $link: link }),
        });
    }
}

export const notificationService = new NotificationService();
